import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Icons } from '@/icons/icons'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerPaginationComponent',
  props: {
  currentPage: {
    type: Number,
    required: true
  },
  totalRegisters: {
    type: Number,
    required: true
  },
  registersPerPage: {
    type: Number,
    default: 5
  }
},
  emits: ['change-page'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n()

// PROPS


// DATA
const icon = {
  left: Icons.ANGLE_LEFT,
  right: Icons.ANGLE_RIGHT
}

const texts = {
  of: t('components.pagination.of'),
  pages: t('components.pagination.pages'),
}

// COMPUTED
const totalPages = computed(() => Math.ceil(props.totalRegisters / props.registersPerPage))

// EVENTS


function changePage(step: 1 | -1) {
  if (props.currentPage === 1 && step === -1) {
    return
  }
  if (props.currentPage === totalPages.value && step === 1) {
    return
  }
  emit('change-page', step)
}

return { __sfc: true,t, props, icon, texts, totalPages, emit, changePage }
}

})